<script setup lang="ts">
import { useI18n } from 'vue-i18n'

defineProps<{
  title: string
  hasToggle: boolean
  item: {
    isAvailable: boolean
    text: string
    phone: string
    mail: string
    website: string
  }
}>()

const { t } = useI18n()

const isOpen = ref(false)

const toggleSection = () => {
  isOpen.value = !isOpen.value
}
</script>
<template>
  <div :class="item.isAvailable ? '' : 'disabled'" class="wrap">
    <h3 v-if="hasToggle" class="f-18">
      <button @click="toggleSection">
        <span>{{ t('practicas.list.employmentLabel') }}</span>
        <Icon v-if="item.isAvailable" name="mini-plus-small" />
      </button>
    </h3>
    <h3 v-else class="f-18">{{ title }}</h3>
    <div v-if="(item.isAvailable && !hasToggle) || (hasToggle && isOpen && item.isAvailable)">
      <div class="description" v-html="item.text" />
      <ul v-if="item.phone || item.mail" class="cul contact-list f-18">
        <li v-if="item.phone">
          <div>
            <span class="f-bold">{{ t('practicas.list.phone') }}</span>
            <span>{{ item.phone }}</span>
          </div>
        </li>
        <li v-if="item.mail">
          <div>
            <span class="f-bold">{{ t('practicas.list.mail') }}</span>
            <span>
              <a :href="`mailto:${item.mail}`">{{ t('practicas.list.mailToMessage') }}</a>
            </span>
          </div>
        </li>
      </ul>
      <TextLink v-if="item.website" :href="item.website" target="_blank">
        {{ t('practicas.list.moreInformation') }}
      </TextLink>
    </div>
    <p v-if="!item.isAvailable" class="status f-18">{{ t('practicas.list.assignedLabel') }}</p>
  </div>
</template>
<style scoped lang="scss">
h3 {
  margin-bottom: 0;
  button {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
}
.status {
  color: var(--c-red-100);
  margin-bottom: 0;
}
:deep(.description) {
  p {
    color: var(--c-gray-75);
    margin-bottom: 0;
    margin-top: 24px;
    @include f-18;
  }
}
.contact-list {
  margin-top: 24px;
  div {
    display: grid;
    grid-template-columns: 90px 1fr;
    span {
      color: var(--c-gray-75);
      &:first-child {
        color: var(--c-primary);
      }
    }
    a {
      text-decoration: none;
    }
  }
}
.text-link {
  margin-top: 24px;
}
</style>
